import { Action } from "..";

import { MaterialBase } from "../../types/materialBase";
import { MATERIAL_CHANGE } from "../actions/material";

export interface MaterialState {
  material: MaterialBase | null;
}

const initialState: MaterialState = {
  material: null,
};

const materialReducer = (
  state: MaterialState = initialState,
  action: Action
): MaterialState => {
  switch (action.type) {
    case MATERIAL_CHANGE:
      return { ...state, material: action.payload };
    default:
      return state;
  }
};

export default materialReducer;
